export const SELECT_ALL_ENTITIES = 'EntityTable/SELECT_ALL_ENTITIES';
export const DESELECT_ALL_ENTITIES = 'EntityTable/DESELECT_ALL_ENTITIES';
export const REMOVE_ENTITY = 'EntityTable/REMOVE_ENTITY';
